class ProductPageAddOns {
  constructor(currentProductHandle, newAddonsArray) {
    this.newAddonsArray = newAddonsArray;
    this.currentProductHandle = currentProductHandle;
    this.cartQueue = [];
    this.addToCartSuccess = new Event("addToCartSuccess");
    this.isPropagationStopped = false;
    this.modalListenerActive = false;
    this.hasAddonData = false;
    this.init();
  }

  async init() {
    if (this.hasAddons()) {
      await this.loadData();

      // Locate the element
      const targetNode = document.querySelector("[data-get-sku]");

      // Configuration object
      const config = {
        childList: true,
        characterData: true,
        subtree: true,
      };

      // Mutation observer callback
      const callback = (mutationsList, observer) => {
        for (const mutation of mutationsList) {
          if (
            mutation.type === "childList" ||
            mutation.type === "characterData"
          ) {
            const newSku = targetNode.textContent;

            if (this.hasProductsToDisplay()) this.changeAddToCartText();
          }
        }
      };

      if (!this.hasProductsToDisplay()) return;

      // Initialize and attach the observer
      const observer = new MutationObserver(callback);
      observer.observe(targetNode, config);

      // Listen for original add-to-cart click
      document.body.addEventListener("click", async function (event) {
        if (
          event.target.matches("[data-btn-addtocart]") &&
          !event._custom &&
          !this.isPropagationStopped
        ) {
          event.stopImmediatePropagation();
          event.preventDefault();

          document
            .getElementById("add-to-cart-button")
            .addEventListener("click", async function (e) {
              e.preventDefault();

              await ProductAddOns.addToShopifyCart();
            });

          await ProductAddOns.handleAddOnsSelectProcess();

          // Re-dispatch the event to continue with native Shopify add-to-cart
          const newEvent = new MouseEvent("click", {
            bubbles: true,
            cancelable: true,
            view: window,
          });

          // Mark the new event to avoid infinite loop
          newEvent._custom = true;
          event.target.dispatchEvent(newEvent);
        } else {
          this.isPropagationStopped = false;
        }
      });
    } else {
      return;
    }
  }

  hasAddons() {
    // Loop add-ons array, and check if metafield for each section === to '' or not. If not, return true
    for (let i = 0; i < this.newAddonsArray.length; i++) {
      const section = this.newAddonsArray[i];
      if (section.metafield !== "") {
        return true;
      }
    }
    return false;
  }

  async loadData() {
    await this.getAddonsBySection(this.newAddonsArray);
  }

  changeAddToCartText() {
    const addToCartButton = document.getElementById("product-add-to-cart");
    addToCartButton.innerText = "CUSTOMIZE";
  }

  async getAddonsBySection(addOnsArray) {
    const addOnData = {
      Handle: this.currentProductHandle,
      "Traction Bars": [],
      "Steering Stabilizers": [],
      "Required Hardware": [],
      "Control Arms": [],
      Accessories: [],
    };
    for (let i = 0; i < addOnsArray.length; i++) {
      const currentSection = addOnsArray[i];
      const sectionSkus = currentSection.metafield;
      const newSkus = await this.fetchAddOns(sectionSkus);
      addOnData[currentSection.name] = newSkus;
    }

    localStorage.removeItem("productAddOns");
    localStorage.setItem("productAddOns", JSON.stringify(addOnData));

    if (!this.hasProductsToDisplay()) {
      console.log("No products to display");
      localStorage.removeItem("productAddOns");
      return;
    }

    // Call the main function to generate sections
    this.generateSections();
  }

  async fetchAddOns(sectionSkus) {
    let addOnSkus = sectionSkus.split(",");

    const productDataPromises = addOnSkus.map((sku) =>
      sku ? this.fetchProductData(sku) : undefined
    );
    const productData = (await Promise.all(productDataPromises)).filter(
      Boolean
    );

    return productData;
  }

  async fetchProductData(sku) {
    const query = ` query {
        products(first:1, query: "${sku}") {
            edges{
                node {
                    id
                    title
                    handle
                    priceRange {
                        minVariantPrice {
                            amount
                        }
                    }
                    featuredImage{
                        url
                    }
                    metafield(namespace: "pim", key: "product_features") {
                      value
                      type
                    }
                    variants(first:1) {
                      edges {
                          node {
                              id
                              sku
                          }
                      }
                  }
                }
            } 
         }
      }`;

    try {
      const response = await this.makeGraphQLRequest(query);
      const edges = response.data.products.edges;
      const product = edges && edges.length > 0 ? edges[0].node : undefined;
      if (!product) {
        return;
      }
      const productData = {
        product: {
          id: product.variants.edges[0].node.id,
          title: product.title,
          handle: product.handle,
          image: product.featuredImage ? product.featuredImage.url : null,
          price: parseFloat(product.priceRange.minVariantPrice.amount).toFixed(
            2
          ),
          features: product.metafield.value,
          sku: product.variants.edges[0].node.sku,
        },
      };
      return productData;
    } catch (error) {
      console.error("Error fetching product:", error);
    }
  }

  showLoading(show) {
    const container = document.getElementById("addOns-spinner-container");
    if (container) {
      container.style.display = show ? "flex" : "none";
    } else {
      console.warn("Loading container not found!");
    }
  }

  async makeGraphQLRequest(query) {
    const response = await fetch(
      "https://bds-suspension.myshopify.com/api/2025-01/graphql.json",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token":
            "488355664613a3f4519a11d10371f3e8",
        },
        body: JSON.stringify({ query }),
      }
    );

    const json = await response.json();
    return json;
  }

  // Fetch productAddOns from localStorage
  getProductAddOns() {
    const storedData = localStorage.getItem("productAddOns");
    return storedData ? JSON.parse(storedData) : null;
  }

  generateSections() {
    const modalBody = document.getElementById("pdp-add-ons-content");
    modalBody.innerHTML = "";

    // Create and append header
    const header = document.createElement("div");
    header.classList.add("addonModal-header");
    header.innerHTML = `
    COMPLETE YOUR BUILD
    <div class="modal-close">
      <button class="close-button" onclick="ProductAddOns.toggleModal()">&times;</button>
    </div>
  `;
    modalBody.appendChild(header);

    const productAddOns = this.getProductAddOns();

    if (!productAddOns) {
      console.warn("No productAddOns found in localStorage.");
      return;
    }

    Object.keys(productAddOns).forEach((key) => {
      if (key === "Handle") return;
      if (productAddOns[key].length === 0) return;

      // Create section
      const section = document.createElement("div");
      section.classList.add("addonModal-section");

      // Add-on section name
      const title = document.createElement("div");
      title.textContent = key.toUpperCase();
      title.classList.add("addonModal-sectionTitle");
      section.appendChild(title);

      // Placeholder for section description
      const desc = document.createElement("div");
      desc.classList.add("placeholder");
      section.appendChild(desc);

      // Fetch and render products
      const productSection = this.generateProductSection(productAddOns[key]);
      section.appendChild(productSection);

      modalBody.appendChild(section);
    });

    if (this.hasProductsToDisplay()) this.changeAddToCartText();
  }

  generateProductSection(productsData) {
    const productSection = document.createElement("div");

    productsData.forEach((productData) => {
      const product = productData.product;
      const productIdFormatted = product.id.replace(
        "gid://shopify/ProductVariant/",
        ""
      );
      const productDiv = document.createElement("div");

      // Product title
      const title = document.createElement("div");
      title.textContent = product.title;
      productDiv.appendChild(title);

      // Layout
      const layout = document.createElement("div");
      layout.classList.add("three-column-layout");

      // Image
      const image = document.createElement("img");
      image.src = product.image;
      layout.appendChild(image);

      // Features
      const features = document.createElement("div");
      features.innerHTML = product.features;
      layout.appendChild(features);

      // Price and CTA
      const cta = document.createElement("div");

      const priceDiv = document.createElement("div");
      priceDiv.classList.add("addonModal-price");
      priceDiv.innerHTML = `Price: <span class="addonModal-amount">$${product.price}</span>`;
      cta.appendChild(priceDiv);

      // New skuDiv
      const skuDiv = document.createElement("div");
      skuDiv.classList.add("addonModal-sku");
      skuDiv.innerHTML = `SKU: <span class="addonModal-sku-number">${product.sku}</span>`;
      cta.insertBefore(skuDiv, priceDiv);

      const qtyAndAddDiv = document.createElement("div");
      qtyAndAddDiv.classList.add("addonModal-quantityAndAdd");

      const qtyInput = document.createElement("input");
      qtyInput.id = `qty-${productIdFormatted}`;
      qtyInput.type = "number";
      qtyInput.value = "1";
      qtyInput.min = 1;
      qtyInput.onkeydown = function (e) {
        if (e.key === "-") {
          e.preventDefault();
        }
      };

      const addButton = document.createElement("button");
      addButton.id = `add-${productIdFormatted}`;
      addButton.innerText = "ADD";

      // Attach event listener
      addButton.addEventListener("click", () => {
        const qty = qtyInput.value;
        this.addToQueue(productIdFormatted, qty);
        addButton.style.backgroundColor = "#006bb6";
        addButton.innerText = "SELECTED";
      });

      qtyAndAddDiv.appendChild(qtyInput);
      qtyAndAddDiv.appendChild(addButton);
      cta.appendChild(qtyAndAddDiv);

      // Add classes
      title.classList.add("addonModal-productTitle");
      layout.classList.add("addonModal-threeColumn");
      image.classList.add("addonModal-productImage");
      features.classList.add("addonModal-productFeatures");
      cta.classList.add("addonModal-productCta");

      layout.appendChild(cta);

      productDiv.appendChild(layout);
      productSection.appendChild(productDiv);
    });

    return productSection;
  }

  addToQueue(productId, qty) {
    this.cartQueue.push({ id: Number(productId), quantity: Number(qty) });
  }

  async handleAddOnsSelectProcess() {
    return new Promise((resolve, reject) => {
      this.toggleModal();

      // Listen for addToCartSuccess event
      document.addEventListener("addToCartSuccess", function () {
        resolve();
      });
    });
  }

  async addToShopifyCart() {
    // If queue is empty, proceed with native Shopify add-to-cart
    if (this.cartQueue.length === 0) {
      this.toggleModal();
      // Dispatch addToCartSuccess event
      document.dispatchEvent(this.addToCartSuccess);
      return;
    }

    const formData = {
      items: this.cartQueue,
    };
    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      // Close modal and clear queue
      this.toggleModal();

      // Dispatch addToCartSuccess event
      document.dispatchEvent(this.addToCartSuccess);
    } catch (error) {
      console.error("Error adding to cart", error);
    }

    this.cartQueue = [];
  }

  closeModalOnClickOutside = (e) => {
    const modalContent = document.getElementById("pdp-add-ons-content");
    if (!modalContent.contains(e.target)) {
      this.toggleModal();
      document.removeEventListener("click", this.closeModalOnClickOutside);
    }
  };

  toggleModal() {
    const modal = document.getElementById("recommended_upgrades_modal");
    if (modal.style.display === "none" || modal.style.display === "") {
      modal.style.display = "block";
      document.body.classList.add("no-scroll");

      if (!this.modalListenerActive) {
        document.addEventListener("click", this.closeModalOnClickOutside);
        this.modalListenerActive = true;
      }
    } else {
      modal.style.display = "none";
      document.body.classList.remove("no-scroll");

      if (this.modalListenerActive) {
        document.removeEventListener("click", this.closeModalOnClickOutside);
        this.modalListenerActive = false;
      }
    }
  }

  hasProductsToDisplay() {
    const productAddOns = this.getProductAddOns();
    if (!productAddOns) return 0;
    // Loop through all getProductAddOns arrays (Accessories, Control Arms, Required Hardware, Steering Stabilizers, Traction Bars) and check if any of them have a length > 0
    for (let i = 0; i < Object.keys(productAddOns).length; i++) {
      const key = Object.keys(productAddOns)[i];
      if (key === "Handle") continue;
      if (productAddOns[key].length > 0) {
        return true;
      }
    }
  }

  reloadAddOns() {
    this.generateSections();
  }

  clearLocalStorage() {
    localStorage.removeItem("productAddOns");
  }
}

// Usage
const ProductAddOns = new ProductPageAddOns(currentProductHandle, addOnsArray);

// Event listener to detect variant change
document.querySelectorAll('select[name*="options"]').forEach((select) => {
  select.addEventListener("change", function () {
    ProductAddOns.reloadAddOns();
  });
});
